import { Container, Point } from 'pixi.js'
import type { dimensions as DimensionsType } from '@/scripts/config/settings'

// Base class for parallax layers.
// Handles position calculations based on a normalized ratio (−0.5 to 0.5).

export default class LayerBase extends Container {
  public override name: string
  public readonly size: Point
  private readonly dims: typeof DimensionsType

  constructor(name: string, layerSize: Point, dimensions: typeof DimensionsType) {
    super()
    this.name = name
    this.size = layerSize
    this.dims = dimensions
  }

  // Sets the layer's position according to a parallax ratio.
  // Ratio values usually range from −0.5 to 0.5.
  public setPosition(ratio: Point): void {
    const { MAX_WIDTH, MAX_HEIGHT } = this.dims
    const x = -(this.size.x - MAX_WIDTH) * ratio.x
    const y = -(this.size.y - MAX_HEIGHT) * ratio.y
    this.position.set(x, y)
  }
}
